<template>
    <div v-if=companydb_id>
        <InvoiceablesListComponent :companydb_id="companydb_id" :invoiceable_type="'delivery_note'"/>
    </div>
</template>

<script>
import InvoiceablesListComponent from '@/modules/facturae/infra/InvoiceablesListComponent.vue'
export default {
    name: 'delivery-note-list',
    components: {
        InvoiceablesListComponent
    },
    
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    
    data() {
        return {
        }
    },
}
</script>